import ChevronRightIconPath from "@ingka/ssr-icon/paths/chevron-right";

export default ChevronRightIconPath;
